(function () {
  'use strict';
  function measure() {
    const meter = document.createElement('div');
    meter.className = 'halo-productBadges';
    meter.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;width:max-content';
    const badge = document.createElement('span');
    badge.className = 'badge sale-badge';
    badge.textContent = 'Sale';
    badge.style.width = 'max-content';
    meter.append(badge);
    document.body.append(meter);
    const width = badge.getBoundingClientRect().width;
    meter.remove();
    if (width) document.documentElement.style.setProperty('--b2b-badge-width', `${width}px`);
  }
  measure();
  if (document.fonts) document.fonts.ready.then(measure);
})();
